/* eslint-disable default-param-last */
export const UPDATE_SELECTED = 'PATIENT_UPDATE_SELECTED'
export const UPDATE_LIST = 'PATIENT_UPDATE_LIST'
export const APPEND_LIST = 'PATIENT_APPEND_LIST'
export const CLEAR_STATE = 'PATIENT_CLEAR_STATE'
export const CLEAR_ALL_STATE = 'CLEAR_ALL_STATE'

type PatientItem = Record<string, unknown>

type PatientState = {
  list: PatientItem[]
  selected: PatientItem
}

type ClearAction = {
  type: typeof CLEAR_STATE | typeof CLEAR_ALL_STATE
}

type UpdateSelectedAction = {
  type: typeof UPDATE_SELECTED
  payload: PatientItem
}

type UpdateListAction = {
  type: typeof UPDATE_LIST
  payload: PatientItem[]
}

type AppendListAction = {
  type: typeof APPEND_LIST
  payload: PatientItem[]
}

type Action = ClearAction | UpdateSelectedAction | UpdateListAction | AppendListAction

const initState: PatientState = {
  list: [],
  selected: {}
}

export default (
  state: PatientState = initState,
  action: Action
): PatientState => {
  switch (action.type) {
    case CLEAR_STATE:
    case CLEAR_ALL_STATE:
      return initState

    case UPDATE_SELECTED:
      return {
        ...state,
        selected: action.payload
      }

    case UPDATE_LIST:
      return {
        ...state,
        list: action.payload
      }

    case APPEND_LIST: {
      const appendedList = state.list.concat(action.payload)
      return {
        ...state,
        list: appendedList
      }
    }

    default:
      return state
  }
}
